import { get, post, patch, del } from './client.js';

const base = (wsId) => `/workspaces/${wsId}/deals`;

export const list = (wsId, params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`${base(wsId)}${q}`);
};

export const getOne = (wsId, dealId) => get(`${base(wsId)}/${dealId}`);
export const create = (wsId, body) => post(base(wsId), body);
export const update = (wsId, dealId, body) => patch(`${base(wsId)}/${dealId}`, body);
export const remove = (wsId, dealId) => del(`${base(wsId)}/${dealId}`);

/* Stage transitions */
export const moveStage = (wsId, dealId, stageId) =>
  post(`${base(wsId)}/${dealId}/stage`, { stageId });

/* Archive / restore */
export const archive = (wsId, dealId) => post(`${base(wsId)}/${dealId}/archive`);
export const restore = (wsId, dealId) => post(`${base(wsId)}/${dealId}/restore`);

/* Pipeline (stage definitions for a workspace) */
export const getPipeline = (wsId, pipelineId) => {
  const url = `/workspaces/${wsId}/pipeline`;
  return get(pipelineId ? `${url}?pipelineId=${encodeURIComponent(pipelineId)}` : url);
};
